module.exports = __webpack_public_path__ + "img/qr-apk-th-page.15ebb43f.png";